import axios from 'axios'
import https from 'https';
import {message} from 'antd'

// let requestCount = 0
// function showLoading () {
//   if (requestCount === 0) {
//       var dom = document.createElement('div')
//       dom.setAttribute('id', 'loading')
//       document.body.appendChild(dom)
//       Component.ReactDOM.render(<Spin tip="加载中..." size="large"/>, dom)
//   }
//   requestCount++
// }
// function hideLoading () {
//   requestCount--
//   if (requestCount === 0) {
//       document.body.removeChild(document.getElementById('loading'))
//   }
// }

const authHeader = `Basic ${btoa('CloudOz:1EEe5SEj3H6rAhk')}`;
export default function ajax(url,data={},type='GET'){

    return new Promise((resolve, reject) => {
        let promise
        if(type==='GET') {
          promise = axios.get(url, { 
            params: data ,
            headers: {
              'Authorization': authHeader
            },timeout: 100000
          })
        } else { 
          promise = axios.post(url, data,{
            headers: {
              'Authorization': authHeader
          }})
        }
        promise.then(response => {
          resolve(response.data)
        }).catch(error => {
          if  (error.message.includes('429 Too Many Requests')){
            message.error('サーバが高負荷状態です。１分後に再実行してください。')
          }
          resolve({status:-1,data:{msg:error.message}})
        })
      })
    
}
const agent = new https.Agent({
  rejectUnauthorized: false // Disable SSL certificate verification
});
const authHeader1 = `Basic ${btoa('admin:1EEe5SEj3H6rAhk')}`;
export  function ajax1(url,data={},type='GET'){

  return new Promise((resolve, reject) => {
      let promise
      if(type==='GET') {
        promise = axios.get(url, { 
          params: data ,
          headers: {
            'Authorization': authHeader1
          },
          httpsAgent: agent
        })
      } else { 
        promise = axios.post(url, data,{
          headers: {
            'Authorization': authHeader1
        },httpsAgent: agent})
      }
      promise.then(response => {
        resolve(response.data)
      }).catch(error => {
        if  (error.message.includes('429 Too Many Requests')){
          message.error('サーバが高負荷状態です。１分後に再実行してください。')
        }
        resolve({status:-1,data:{msg:error.message}})
      })
    })
  
}
